import React from "react";

// Services && Constants
import { dateWithTimezone } from "src/services/date";

// Components
import ArrivalDelay from "src/views/practitioner/components/ArrivalDelay";

// Styles
import s from "./TimeBlockForTable.style";

const TimeBlockForTable = ({ appointment }) => {
  return (
    <s.TimeBlock>
      <div className="time-line" />

      <div className="time-indicator">
        <span> {dateWithTimezone(appointment && appointment.dateTime)}</span>
        <ArrivalDelay appointment={appointment} />
      </div>
    </s.TimeBlock>
  );
};

export default TimeBlockForTable;
